import React, { useRef } from "react";
import { ChevronLeft, ChevronRight, ExternalLink } from "lucide-react";

const YouTubeShortsSlider = () => {
  const sliderRef = useRef(null);

  // Real Shorts video IDs
  const shorts = [
    "E4ilRUEqu4w",
    "dftLAEdz65U",
    "2zEXy5mMiKk",
    "O4KGRJmH6fI",
    "BT_gwnELec8",
    "heOv9xKP4xQ"
  ];

  const scroll = (direction) => {
    const container = sliderRef.current;
    const scrollAmount = 320;

    if (!container) return;

    container.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  const openChannel = () => {
    window.open(
      "https://www.youtube.com/@KnightCleanings",
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4">

        {/* Header */}
        <div className="text-center mb-10">
          <h2 className="text-4xl font-bold mb-4">
            Watch Our Cleaning in Action
          </h2>
          <p className="text-gray-600">
            Real cleaning transformations from Knight Cleanings
          </p>
        </div>

        {/* Slider */}
        <div className="relative">

          {/* Left Button */}
          <button
            onClick={() => scroll("left")}
            className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-md w-10 h-10 rounded-full flex items-center justify-center hover:bg-gray-100"
          >
            <ChevronLeft />
          </button>

          {/* Right Button */}
          <button
            onClick={() => scroll("right")}
            className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-md w-10 h-10 rounded-full flex items-center justify-center hover:bg-gray-100"
          >
            <ChevronRight />
          </button>

          {/* Scroll Container */}
          <div
            ref={sliderRef}
            className="flex gap-6 overflow-x-auto scroll-smooth px-12"
            style={{ scrollbarWidth: "none" }}
          >
            {shorts.map((videoId, index) => (
              <div
                key={index}
                className="min-w-[280px] max-w-[280px] flex-shrink-0"
              >
                <div className="relative rounded-2xl overflow-hidden shadow-lg">


                  {/* Embedded Short */}
                  <iframe
                    className="w-full h-[500px]"
                    src={`https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1`}
                    title="YouTube Short"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>

                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12">
          <button
            onClick={openChannel}
            className="bg-red-600 text-white px-8 py-3 rounded-full hover:bg-red-700 transition flex items-center gap-2 mx-auto"
          >
            <ExternalLink size={18} />
            Visit @KnightCleanings Channel
          </button>
          <p className="text-gray-500 mt-3 text-sm">
            Watch more cleaning transformations and professional tips
          </p>
        </div>

      </div>
    </section>
  );
};

export default YouTubeShortsSlider;
